import React, {FC} from 'react';

import {AdditionalInfo} from '@optimaxdev/icons';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';
import {PRODUCT_TYPES} from 'constants/product';

import {Notification} from '../notification/notification';

type PropsType = {
    item: QuoteItemV2;
};

/**
 * Component for render notification
 */
export const StockNotification: FC<PropsType> = ({item}) => {
    if (item.product.stock?.isOutOfStock) {
        const notFrame =
            item.product.type === PRODUCT_TYPES.ACCESSORY ||
            item.product.type === PRODUCT_TYPES.CONTACT_LENSES;
        return (
            <Notification icon={AdditionalInfo} type="error">
                This {notFrame ? 'product' : 'frame'} is out of stock.
            </Notification>
        );
    }

    if (item.product.stock?.isLowStock)
        return (
            <Notification icon={AdditionalInfo} type="warning">
                Act fast, only a few left in stock!
            </Notification>
        );

    return null;
};
